import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

interface Popup {
  id: string;
  title: string | null;
  content: string | null;
  image_url: string | null;
}

export default function AnnouncementPopup() {
  const [popup, setPopup] = useState<Popup | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    supabase
      .from('popups')
      .select('id, title, content, image_url')
      .eq('is_active', true)
      .limit(1)
      .maybeSingle()
      .then(({ data }) => {
        if (!data) return;
        const dismissedId = localStorage.getItem('popup_dismissed_id');
        const dismissedUntil = Number(localStorage.getItem('popup_dismissed_until') ?? 0);
        if (dismissedId === data.id && Date.now() < dismissedUntil) return;
        setPopup(data);
        setVisible(true);
      });
  }, []);

  if (!visible || !popup) return null;

  const close = () => setVisible(false);

  const dismissForToday = () => {
    localStorage.setItem('popup_dismissed_id', popup.id);
    localStorage.setItem('popup_dismissed_until', String(Date.now() + 24 * 60 * 60 * 1000));
    setVisible(false);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 px-4">
      <div className="relative w-full max-w-md rounded-2xl bg-background-100 border border-white/10 overflow-hidden shadow-2xl">
        <button
          type="button"
          onClick={close}
          aria-label="닫기"
          className="absolute top-3 right-3 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-black/40 text-white/80 hover:bg-black/60 hover:text-white transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-lg"></i>
        </button>

        {popup.image_url && (
          <img src={popup.image_url} alt={popup.title ?? '공지'} className="w-full max-h-[420px] object-cover" />
        )}

        {(popup.title || popup.content) && (
          <div className="p-6">
            {popup.title && (
              <h3 className="font-display text-lg font-semibold text-white mb-2">{popup.title}</h3>
            )}
            {popup.content && (
              <p className="text-sm text-foreground-300 leading-relaxed whitespace-pre-wrap">
                {popup.content}
              </p>
            )}
          </div>
        )}

        <div className="flex items-center justify-between px-6 py-4 border-t border-white/5">
          <button
            type="button"
            onClick={dismissForToday}
            className="text-xs text-foreground-500 hover:text-white transition-colors cursor-pointer"
          >
            오늘 하루 보지 않기
          </button>
          <button
            type="button"
            onClick={close}
            className="px-4 py-2 rounded-lg bg-primary-500 text-foreground-950 text-xs font-medium hover:bg-primary-400 transition-colors cursor-pointer"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
}
